<div class="form-group">
    <label for="InputFechaEntrega">{{label}}</label>
    <div class="input-group input-group-lg mb-3">
        <div class="input-group-prepend">
            <span class="input-group-text"><i class="fas fa-calendar-alt"></i></span>
        </div>
        <input 
            type="text" 
            class="form-control" 
            bsDaterangepicker  
            [(ngModel)]="bsRangeValue" 
            [id]="idForm" 
            [placeholder]="placeholder"
            autocomplete="off"
            [bsConfig]="{   
                isAnimated: true, 
                dateInputFormat: 'DD/MM/YYYY', 
                containerClass: 'theme-dark-blue',  
                returnFocusToInput: true 
            }"
            (bsValueChange)="onValueChange($event)">
    </div>
</div>